import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["button", "input"]
  static values = {
    target: String,
    radioSelector: String,
    numMonthsSelector: String,
    monthsSelector: String,
    paymentsSelector: String
  }

  connect() {
    this.setupDropdown()
  }

  setupDropdown() {
    const $items = window.$(this.element).find("li a")
    const self = this

    $items.on("click", function(e) {
      e.preventDefault()
      const htmlString = window.$(this).html()

      // Update button text
      if (self.hasButtonTarget) {
        self.buttonTarget.innerHTML = htmlString + '<span class="caret"></span>'
      }

      // Update hidden input
      if (self.hasInputTarget) {
        self.inputTarget.value = htmlString
      }

      // Trigger radio button click if specified
      if (self.hasRadioSelectorValue) {
        const radioElement = document.querySelector(self.radioSelectorValue)
        if (radioElement) {
          radioElement.click()
        }
      }

      // Handle num-months display logic
      if (self.hasNumMonthsSelectorValue) {
        const numMonthsElement = document.querySelector(self.numMonthsSelectorValue)
        if (numMonthsElement) {
          if (htmlString == '6') {
            numMonthsElement.innerHTML = '12'
          } else {
            numMonthsElement.innerHTML = htmlString
          }
        }
      }

      // Handle months text (singular/plural)
      if (self.hasMonthsSelectorValue) {
        const monthsElement = document.querySelector(self.monthsSelectorValue)
        if (monthsElement) {
          if (htmlString == '1') {
            monthsElement.innerHTML = 'month'
          } else {
            monthsElement.innerHTML = 'months'
          }
        }
      }

      // Handle payments text (singular/plural)
      if (self.hasPaymentsSelectorValue) {
        const paymentsElement = document.querySelector(self.paymentsSelectorValue)
        if (paymentsElement) {
          if (htmlString == '1') {
            paymentsElement.innerHTML = 'payment'
          } else {
            paymentsElement.innerHTML = 'monthly payments'
          }
        }
      }
    })
  }
}
